import BoldText from '@/components/BoldText';
import userPlans from '@/hooks/userPlans';
import settingsSlice, { cssSelector } from '@/redux/slice/settings.slice';
import { Editor } from '@monaco-editor/react';
import { Card, InlineGrid, Text, Tooltip } from '@shopify/polaris';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

function CustomCSS() {
  const { t } = useTranslation(['common', 'settings']);
  const dispatch = useDispatch();

  const css = useSelector(cssSelector);

  const { userPlanFree, shopifyPlanPlus } = userPlans();
  const contentTooltip =
    userPlanFree && shopifyPlanPlus ? t('common:available_on_shopify_plus') : t('common:available_on_premium_plan');

  const handleUpdatedCSS = (value: any) => {
    dispatch(settingsSlice.actions.handleCss(value));
  };

  return (
    <InlineGrid columns={1} gap={'400'}>
      <Card>
        <BoldText>{t('settings:custom_css')}</BoldText>
        <div className="mt-8 mb-16">
          <Text as="p" tone="subdued">
            {t('settings:apply_custom_css_blocking_page')}
          </Text>
        </div>
        {userPlanFree ? (
          <Tooltip content={contentTooltip}>
            <div className="custom-css">
              <Editor
                height="55vh"
                defaultLanguage="css"
                value={css}
                options={{
                  selectOnLineNumbers: true,
                }}
                theme="vs-dark"
              />
              <div className="overlay" />
            </div>
          </Tooltip>
        ) : (
          <div className="mt-8">
            <Editor
              height="55vh"
              defaultLanguage="css"
              value={css}
              options={{
                selectOnLineNumbers: true,
              }}
              onChange={handleUpdatedCSS}
              theme="vs-dark"
            />
          </div>
        )}
      </Card>
    </InlineGrid>
  );
}

export default memo(CustomCSS);
